import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'cms-site-header',
  name: '站点头部',
  icon: '站',
  group: 'CMS通用',
  description: '站点名称显示与站点切换入口。',
  defaultProps: {
    showSwitch: true,
    switchLabel: '切换',
    showSearch: true,
    searchPlaceholder: '搜索内容'
  }
}
